import type { AxiosError } from 'axios'

/**
 * Given an error caught from an Axios request, converts it to a human-
 * readable error message (suitable for displaying on-screen) and throws that
 * string.
 */
export default function handleAxiosError(error: AxiosError) {

  console.error('error:', error)

  // https://axios-http.com/docs/handling_errors

  if (error.response) {
    // The HTTP request completed, but the server responded with a non-2xx
    // status.
    // Some endpoints return errors as simple strings; others return arrays of
    // strings.
    if (Array.isArray(error.response.data)) {
      throw error.response.data.join('; ')
    } else {
      throw error.response.data
    }
  } else if (error.request) {
    // The request was made but no response was received
    throw 'Unknown error. Are you connected to the internet?'
  } else {
    throw 'Unknown error. Are you connected to the internet?'
  }

}
